import React, { forwardRef } from 'react';
var Column = /*#__PURE__*/forwardRef(function (props, ref) {
  // const {
  //     sortKey = '',
  //     field = '',
  //     sortId = String.fromCharCode(65 + Math.floor(Math.random() * 26)) + Date.now(),
  //     slot = 'end',
  //     prefix,
  //     sortFunc1,
  //     sortFunc2,
  //     children
  // } = props;

  return /*#__PURE__*/React.createElement("th", {
    ref: ref
  }, /*#__PURE__*/React.createElement("span", null, props.children));
});
export default Column;